module.exports = __webpack_public_path__ + "static/media/defects.aaa3dc79.svg";